import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BookingRedirectGuard implements CanActivate {
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const url = state.url;
    
    // Check if URL starts with /account or /book
    if (url.startsWith('/account') || url.startsWith('/book')) {
      // Redirect to bookingBaseUrl with the full path
      window.location.href = `${environment.bookingBaseUrl}${url}`;
      return false;
    }
    
    return true;
  }
}
